export default __webpack_public_path__ + "static/media/testify14.fc92c84b.png";